import { IGuestCartItem } from './interfaces';

// interface PriceData {
//   price: number;
//   delivery: null | number;
//   opt_price?: number;
// }

export function calculatePrice(
  quantity: number,
  prices?: { price: number; amount: number }[]
): number {
  // Если список цен пустой, или quantity <= 0, возвращаем 0
  if (!prices || prices.length === 0 || quantity <= 0) {
    return 0;
  }

  // Сортируем цены по возрастанию количества
  const sortedPrices = [...prices].sort((a, b) => a.amount - b.amount);

  let selectedPrice: number = 0; // Инициализируем выбранную цену нулем

  // Находим ближайшую цену, где количество меньше или равно запрошенному
  for (const priceEntry of sortedPrices) {
    if (priceEntry.amount <= quantity) {
      selectedPrice = priceEntry.price;
    } else {
      // Поскольку цены отсортированы, можем остановиться, как только превысили количество
      break;
    }
  }

  // Если подходящая запись найдена (selectedPrice будет обновлена), возвращаем её.
  // Если нет (т.е. quantity меньше всех amount), вернется либо 0 (изначальное значение),
  // либо цена для наименьшего доступного количества, если мы хотим, чтобы была хоть какая-то цена.
  // В данном случае, если quantity меньше всех amount, будет возвращена price для наименьшего amount.
  if (selectedPrice === 0 && sortedPrices.length > 0 && quantity > 0) {
    // Если по каким-то причинам selectedPrice остался 0, но есть цены и quantity > 0,
    // это означает, что quantity меньше первого amount.
    // Тогда возвращаем цену для самого низкого amount.
    return sortedPrices[0].price;
  }

  return selectedPrice;
}

export function calculateOrderTotal(products: IGuestCartItem[]): number {
  let total = 0;

  for (const product of products) {
    const productPrice =
      calculatePrice(product.count, product.priceValue?.prices);
    total += productPrice * product.count;
  }

  return total;
}
